import { cn } from "@/lib/utils";

interface KeyPillProps {
  keyName: string;
  onClick?: () => void;
}

const baseClassName =
  "inline-flex h-7 shrink-0 items-center rounded-md border border-slate-200 bg-white px-2.5 text-sm font-medium text-slate-600 shadow-sm shadow-slate-200/70";

const KeyPill = ({ keyName, onClick }: KeyPillProps) => {
  if (!onClick) {
    return <span className={baseClassName}>{keyName}</span>;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        baseClassName,
        "transition-colors hover:border-slate-300 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200",
      )}
    >
      {keyName}
    </button>
  );
};

export default KeyPill;
